import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule } from '@ngx-translate/core';
import { UploadsModule } from "@progress/kendo-angular-upload";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { AppCommonModule } from '../../components/common/app-common.module';
import { RaciStepsPaneComponent } from './components/raci-steps-pane/raci-steps-pane.component';
import { RaciChecklistPaneComponent } from './components/raci-checklist-pane/raci-checklist-pane.component';
import { RaciHostComponent } from './raci-host/raci-host.component';
import { RaciParticipantsPaneComponent } from './components/raci-participants-pane/raci-participants-pane.component';
import { RaciService } from './services/raci.service';
import { TreeListViewComponent } from './components/tree-list-view/tree-list-view.component';
import { PortfolioPropertiesComponent } from './components/portfolio-properties/portfolio-properties.component';
import { UserDashboardModule } from '../user-dashboard/user-dashboard.module';

/**
 * The routes
 */
export const routerModule = RouterModule.forChild([
  {
    path: '',
    component: RaciHostComponent
  }
]);

/**
 * AoT requires an exported function for factories
 * @param http HttpClient
 */
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translation/lang-', '.json');
}

/**
 * RACI module
 */
@NgModule({
  imports: [
    CommonModule,
    routerModule,
    GridModule,
    DropDownsModule,
    ReactiveFormsModule,
    ButtonsModule,
    TranslateModule,
    UploadsModule,
    FormsModule,
    LayoutModule,
    InputsModule,
    AppCommonModule,
    UserDashboardModule
  ],
  declarations: [
    RaciStepsPaneComponent,
    RaciChecklistPaneComponent,
    RaciHostComponent,
    RaciParticipantsPaneComponent,
    TreeListViewComponent,
    PortfolioPropertiesComponent
  ],
  exports: [
    RaciHostComponent
  ],
  providers: [
    RaciService
  ]
})
export class RaciModule { }
